import getAppRoot from '../../../utils/getAppRoot';
import { SmsAddonSubscribedDtoModelType } from '../../../models';

export default ({ store, requestUuid }: SmsAddonSubscribedDtoModelType) => {
  const rootStore = getAppRoot(store);
  rootStore.billing.onSmsAddonSubscribed(requestUuid ?? '');
};
